/**
 * @fileoverview Profile Redux Selectors
 * @active Used in current Next.js App Router routes
 * 
 * These selectors are used by active components in the App Router implementation
 * to access user profile information, connection status, accreditation, and notification settings.
 * 
 * @see {@link src/components/companies/NewCompanies.tsx} - ACTIVE component that uses these selectors
 * @see {@link src/store/profile/profile.slice.ts} - Profile state management
 */

import type { RootState } from '../index';

const getUserProfileInfo = () => (state: RootState) => state.profile.profile;
const getCountPage = () => (state: RootState) => state.profile.countPage;
const getIsConnected = () => (state: RootState) => state.profile.isConnected;
const getAccreditation = () => (state: RootState) => state.profile.accreditationQuestions;
const getNotificationsSettings = () => (state: RootState) =>
  state.profile.notificationsSettings;
const getUserNotificationsSettings = () => (state: RootState) =>
  state.profile.userNotificationsSettings;
const getAccreditationForm = () => (state: RootState) => state.profile.accreditationForm;

export {
  getUserProfileInfo,
  getIsConnected,
  getAccreditation,
  getNotificationsSettings,
  getUserNotificationsSettings,
  getAccreditationForm,
  getCountPage,
};
